import React from 'react';
import { Box, Typography, Paper, Divider } from '@mui/material';
import { motion } from 'framer-motion';

const policyVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

export const TermsAndConditions = () => {
  return (
    <Box sx={{ py: 5, px: { xs: 2, md: 6 }, backgroundColor: 'None', minHeight: '100vh' }}>
      <motion.div initial="hidden" animate="visible" variants={policyVariants}>
        <Paper elevation={4} sx={{ p: { xs: 3, md: 5 }, borderRadius: 1, background: 'rgb(259,259,259,0.8)' }}>
          <Typography variant="h4" fontWeight="bold" gutterBottom fontFamily="Playfair Display" color="success">
             Terms and Conditions – MazGuard
          </Typography>
          <Typography variant="subtitle2" gutterBottom color="text.secondary">
            Effective Date: 7/7/2025
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="body1" gutterBottom>
            These Terms govern your use of <strong>MazGuard</strong>, a community-powered environmental reporting platform
            designed to help protect ecosystems and promote sustainability.
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="h6" fontWeight="bold">1. Purpose of the Platform</Typography>
          <Typography variant="body2" gutterBottom>
            MazGuard is intended exclusively for reporting environmental issues such as:
            <ul>
              <li>Illegal dumping or waste</li>
              <li>Air, water, or soil pollution</li>
              <li>Deforestation and wildlife threats</li>
              <li>Hazardous material spills</li>
              <li>Any other activity that harms the environment</li>
            </ul>
          </Typography>

          <Typography variant="h6" fontWeight="bold">2. Acceptable Use</Typography>
          <Typography variant="body2" gutterBottom>
            By using MazGuard, you agree to:
            <ul>
              <li>Submit truthful, evidence-backed reports</li>
              <li>Not use the platform for defamation, harassment, or false reporting</li>
              <li>Refrain from uploading violent, misleading, or harmful content</li>
            </ul>
          </Typography>

          <Typography variant="h6" fontWeight="bold">3. Account Use (if applicable)</Typography>
          <Typography variant="body2" gutterBottom>
            <ul>
              <li>You are responsible for your account credentials</li>
              <li>MazGuard may revoke access if misuse is detected</li>
            </ul>
          </Typography>

          <Typography variant="h6" fontWeight="bold">4. Report Verification</Typography>
          <Typography variant="body2" gutterBottom>
            <ul>
              <li>All reports are subject to review and may be forwarded to the relevant environmental body</li>
              <li>Submission of a report does not guarantee action or resolution</li>
            </ul>
          </Typography>

          <Typography variant="h6" fontWeight="bold">5. Media Ownership</Typography>
          <Typography variant="body2" gutterBottom>
            <ul>
              <li>You retain rights to media (photos/videos) you upload</li>
              <li>By submitting, you grant MazGuard non-exclusive rights to use your media for environmental awareness, reporting, and education</li>
            </ul>
          </Typography>

          <Typography variant="h6" fontWeight="bold">6. Platform Limitations</Typography>
          <Typography variant="body2" gutterBottom>
            MazGuard does not:
            <ul>
              <li>Guarantee agency response</li>
              <li>Offer emergency services (use local emergency contacts if urgent)</li>
              <li>Replace legal or regulatory reporting processes</li>
            </ul>
          </Typography>

          <Typography variant="h6" fontWeight="bold">7. Limitation of Liability</Typography>
          <Typography variant="body2" gutterBottom>
            MazGuard is offered “as-is” without warranties. We are not liable for:
            <ul>
              <li>Report inaccuracies</li>
              <li>Delayed or missed follow-ups</li>
              <li>Actions taken by third parties based on your report</li>
            </ul>
          </Typography>

          <Typography variant="h6" fontWeight="bold">8. Termination</Typography>
          <Typography variant="body2" gutterBottom>
            We reserve the right to suspend or terminate users who:
            <ul>
              <li>Misuse the platform</li>
              <li>Submit fraudulent or malicious reports</li>
              <li>Violate community/environmental protection ethics</li>
            </ul>
          </Typography>

          <Typography variant="h6" fontWeight="bold">9. Governing Law</Typography>
          <Typography variant="body2" gutterBottom>
            These terms are governed by the environmental and digital protection laws of Kenya.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" fontWeight="bold">10. Contact Us</Typography>
          <Typography variant="body2" gutterBottom>
            For inquiries, corrections, or suggestions, reach us at:
            <br />
            <strong>Email:</strong> korirbyron1@gmail.com<br />
            <strong>Phone:</strong> 0725499649<br />
            {/* <strong>Address:</strong> [Insert Office/PO Box if applicable] */}
          </Typography>
        </Paper>
      </motion.div>
    </Box>
  );
};

//  TermsAndConditions;
